import FaqPanel from './FaqPanel';

export default FaqPanel;
